import {DeviceResponseInterface} from "../../interfaces/device.interface";

export const deviceInitialState: DeviceResponseInterface = {
    requestState: 'IDLE',
    cameraId: undefined,
    cameraLabel: undefined,
}
